import { render, staticRenderFns } from "./group.vue?vue&type=template&id=579ef497&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579ef497",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579ef497')) {
      api.createRecord('579ef497', component.options)
    } else {
      api.reload('579ef497', component.options)
    }
    module.hot.accept("./group.vue?vue&type=template&id=579ef497&scoped=true", function () {
      api.rerender('579ef497', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/main/src/page/manage/content/group.vue"
export default component.exports